import { render, staticRenderFns } from "./AccountTagsPopover.vue?vue&type=template&id=0e68576a&scoped=true&"
import script from "./AccountTagsPopover.vue?vue&type=script&lang=js&"
export * from "./AccountTagsPopover.vue?vue&type=script&lang=js&"
import style0 from "./AccountTagsPopover.vue?vue&type=style&index=0&id=0e68576a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e68576a",
  null
  
)

export default component.exports